import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';

@Component({
    selector: 'app-sumsubaudit',
    templateUrl: './sumsubaudit.component.html',
    styleUrls: ['./sumsubaudit.component.css']
})
export class SumsubAuditComponent implements OnInit {
    filter: any = {
        fromDate: moment().format('yyyy-MM-DD'),
        toDate: moment().format('yyyy-MM-DD')
    };
    displayedColumns = [
        'applicantId',
        'inspectionId',
        'applicantType',
        'correlationId',
        'levelName',
        'sandboxMode',
        'userEmail',
        'type',
        'reviewResult',
        'reviewStatus',
        'clientId',
        'createdAtMs',
        'createdAt',
    ];
    public dataSource: any = new MatTableDataSource();
    pageSize = 25;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.applyRefreshData();
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.filter['fromDate'] = moment(event.value).format('yyyy-MM-DD');
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.filter['toDate'] = moment(event.value).format('yyyy-MM-DD');
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.userService.getAllSumsubAudit(this.filter).subscribe((success) => {
                let sumsubAuditRes = success.map(sumsubAudit => {
                    sumsubAudit.createdAtMs = moment(sumsubAudit.createdAtMs).format('MM/DD/YY h:mm:ss A');
                    sumsubAudit.createdAt = moment(sumsubAudit.createdAt).format('MM/DD/YY h:mm:ss A');
                    return sumsubAudit;
                })
                this.dataSource = new MatTableDataSource(sumsubAuditRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const sumsubaudit = await this.dataSource.filteredData.map(x => ({
                'applicantId': x.applicantId,
                'inspectionId': x.inspectionId,
                'applicantType': x.applicantType,
                'correlationId': x.correlationId,
                'levelName': x.levelName,
                'sandboxMode': x.sandboxMode,
                'userEmail': x.userEmail,
                'type': x.type,
                'reviewResult': x.reviewResult,
                'reviewStatus': x.reviewStatus,
                'clientId': x.clientId,
                'createdAtMs': x.createdAtMs,
                'createdAt': x.createdAt
            }));
            TableUtil.exportArrayToExcel(sumsubaudit, "sumsubaudit");
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/sumsubaudit/sumsubaudit.component.ts